import React, {useEffect, useState} from 'react';
import jalaali from 'jalaali-js';
import {Chip, IconButton, Typography} from '@material-tailwind/react';
import {BsArrowLeft, BsArrowRight} from "react-icons/bs";
import PersianNumberFormat from "../../../helper/PersianNumberFormat";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import {CalendarForm} from "./form";
import {ReservationInfoForm} from "../../schedule/reservation_info_form";
import {ReservationForm} from "../../reservation/form";
import {Toaster} from "../../../helper/Toaster";

export function Calendar({
                           eventList,
                           onEvent,
                           onNavigate,
                           Type,
                           lastDataRefresh,
                           setLastDataRefresh,
                           payedReservation,
                           agent_id,
                           branch_id,
                           person_id,
                         }) {

  const [calenderType, setCalenderType] = useState(Type);
  const [currentDate, setCurrentDate] = useState(jalaali.toJalaali(new Date()));
  const [modalOpen, setModalOpen] = useState(false);
  const [reserveModalOpen, setReserveModalOpen] = useState(false);
  const [reserveFormModalOpen, setReserveFormModalOpen] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState({});
  const [selectedReservationId, setSelectedReservationId] = useState(null);
  const [selectedScheduleToReserve, setSelectedScheduleToReserve] = useState({});
  const [agentId, setAgentId] = useState(agent_id);
  const [branchId, setBranchId] = useState(branch_id);
  const [personId, setPersonId] = useState(person_id);

  useEffect(() => {
    setPersonId(person_id);
  }, [person_id]);

  useEffect(() => {
    const el = eventList.map((ev, idx) => {
      ev['dateObj'] = new Date(ev.date);
      return ev;
    });

    setEvents(el);
  }, [eventList, lastDataRefresh]);


  useEffect(() => {
    if (payedReservation) {
      const selectedSchedule = {
        "day": parseInt(payedReservation.jalaliDate.split("-")[2]),
        "events": payedReservation.SelectedSchedule,
        "jalaliDate": payedReservation.jalaliDate,
      }
      setSelectedScheduleToReserve(selectedSchedule);
      setReserveFormModalOpen(true)
    }
  }, [payedReservation]);

  const navigateHandler = (jy, jm) => {
    const monthDays = jalaali.jalaaliMonthLength(jy, jm);
    onNavigate && onNavigate(jy, jm, monthDays)
  }
  const getDaysInMonth = (year, month) => {
    const result = [];
    const monthDays = jalaali.jalaaliMonthLength(year, month);

    for (let i = 1; i <= monthDays; i++) {
      result.push(i);
    }

    return result;
  };

  const getMonthName = (month) => {
    const monthNames = [
      'Farvardin', 'Ordibehesht', 'Khordad', 'Tir', 'Mordad', 'Shahrivar',
      'Mehr', 'Aban', 'Azar', 'Dey', 'Bahman', 'Esfand'
    ];
    return monthNames[month - 1];
  };

  const handlePrevMonth = () => {
    let {jy, jm} = currentDate;
    jm -= 1;
    if (jm === 0) {
      jm = 12;
      jy -= 1;
    }
    setCurrentDate({jy, jm, jd: 1});
    navigateHandler(jy, jm);
  };

  function getDayOfWeek(jy, jm, jd) {
    const {gy, gm, gd} = jalaali.toGregorian(jy, jm, jd);
    const date = new Date(gy, gm - 1, gd); // Months are 0-indexed in JavaScript
    const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayOfWeek = weekdays[date.getDay()];
    return dayOfWeek;
  }

  function convertJalaliToGregorian(jalaliDate) {
    const [jy, jm, jd] = jalaliDate.split('-').map(Number);
    const {gy, gm, gd} = jalaali.toGregorian(jy, jm, jd);
    const gregorianDate = `${gy.toString().padStart(4, '0')}-${gm.toString().padStart(2, '0')}-${gd.toString().padStart(2, '0')}`;
    return gregorianDate;
  }

  const handleNextMonth = () => {
    let {jy, jm} = currentDate;
    jm += 1;
    if (jm === 13) {
      jm = 1;
      jy += 1;
    }
    setCurrentDate({jy, jm, jd: 1});
    navigateHandler(jy, jm);
  };

  let days = getDaysInMonth(currentDate.jy, currentDate.jm);

  days = days.map((day, index) => {
    const jalaliDate = [currentDate.jy.toString().padStart(4, '0'), currentDate.jm.toString().padStart(2, '0'), day.toString().padStart(2, '0')].join('-');
    const date = convertJalaliToGregorian(jalaliDate);

    const filteredEvents = events.filter(evnt => evnt.date === date);

    return {
      'day': day,
      'jalaliDate': jalaliDate,
      'events': filteredEvents
    };
  });

  const monthName = getMonthName(currentDate.jm);

  // Jalaali week days
  const weekDays = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
  const persianDays = {
    'Saturday': 'شنبه',
    'Sunday': 'یکشنبه',
    'Monday': 'دوشنبه',
    'Tuesday': 'سه‌شنبه',
    'Wednesday': 'چهارشنبه',
    'Thursday': 'پنجشنبه',
    'Friday': 'جمعه'
  };

  const persianMonths = {
    "Farvardin": "فروردین",
    "Ordibehesht": "اردیبهشت",
    "Khordad": "خرداد",
    "Tir": "تیر",
    "Mordad": "مرداد",
    "Shahrivar": "شهریور",
    "Mehr": "مهر",
    "Aban": "آبان",
    "Azar": "آذر",
    "Dey": "دی",
    "Bahman": "بهمن",
    "Esfand": "اسفند"
  };

  // Calculate the first day of the month to align correctly
  const firstWeek = jalaali.jalaaliWeek(currentDate.jy, currentDate.jm, 1);

  const firstDayOfMonth = getDayOfWeek(currentDate.jy, currentDate.jm, 1);
  const len = weekDays.indexOf(firstDayOfMonth);
  const prefixDays = Array(len || 0).fill(null);


  return (
    <div className="">
      {modalOpen && <CalendarForm open={modalOpen}
                                  setOpen={setModalOpen}
                                  setLastDataRefresh={setLastDataRefresh}
                                  event={selectedEvent}
                                  onSave={onEvent}
      />}
      {reserveModalOpen && <ReservationInfoForm open={reserveModalOpen}
                                                setOpen={setReserveModalOpen}
                                                reservationId={selectedReservationId}
      />}
      {reserveFormModalOpen && <ReservationForm open={reserveFormModalOpen}
                                                setOpen={setReserveFormModalOpen}
                                                setLastDataRefresh={setLastDataRefresh}
                                                event={selectedScheduleToReserve}
                                                payedReservation={payedReservation}
                                                agent_id={agentId}
                                                branch_id={branchId}
                                                person_id={personId}
      />}
      <div className="flex justify-between items-center mb-4">
        <IconButton className="mt-4" onClick={handleNextMonth} color="">
          <BsArrowRight className="w-6 h-6"/>
        </IconButton>
        <h2 className="text-2xl font-bold">
          {persianMonths[monthName]} {persianNumberFormat(currentDate.jy)}
        </h2>
        <IconButton className="mt-4" onClick={handlePrevMonth} color="">
          <BsArrowLeft className="w-6 h-6"/>
        </IconButton>
      </div>
      <div className="grid grid-cols-7 gap-2 mb-2">
        {weekDays.map((day, index) => (
          <div key={index} className="text-center font-bold">
            {persianDays[day]}
          </div>
        ))}
      </div>
      <div className="grid grid-cols-7">
        {prefixDays.map((_, index) => (
          <div key={index} className="text-center rounded-lg h-20 flex items-center justify-center"></div>
        ))}

        {days.map(({day, jalaliDate, events}, index) => (
          <div
            key={index}
            className="border border-gray-300 text-center h-32 flex items-center flex-col"
            onClick={() => {
              if (calenderType === 'schedule') {
                setSelectedEvent({
                  'day': day,
                  'jalaliDate': jalaliDate,
                  'events': [],
                });
                setModalOpen(true);
              }
            }}
          >
            <span className="my-2 text-gray-700 text-sm font-semibold">({PersianNumberFormat(day)})</span>
            {events.map(({id, from, to, title, week_day_id, type}, index) => (

              <Chip
                className="font-extralight px-2 mx-1 w-full hover:cursor-pointer overflow-x-clip md:hover:overflow-x-visible"
                color={type === "reserve" ? "green" : "blue"}
                variant={"ghost"}
                value={" ◉ " + title + " (" + persianNumberFormat(to) + " ـ " + persianNumberFormat(from) + ")"}
                onClick={(e) => {
                  e.stopPropagation();
                  if (type === 'schedule' && calenderType === 'schedule') {
                    setSelectedEvent({
                      "id": id,
                      "week_day_id": week_day_id,
                      'day': day,
                      'jalaliDate': jalaliDate,
                      "from": from,
                      "to": to,
                      // 'events': events,
                    })
                    setModalOpen(true);
                  } else if (type === 'reserve' && calenderType === 'schedule') {
                    setSelectedReservationId(id)
                    setReserveModalOpen(true);
                  } else if (type === 'schedule' && calenderType === 'reservation') {
                    const eventGorg = jalaali.toGregorian(parseInt(jalaliDate.split('-')[0]), parseInt(jalaliDate.split('-')[1]), parseInt(jalaliDate.split('-')[2]))
                    if (Date.now() > Date.parse(`${eventGorg.gy}-${eventGorg.gm}-${eventGorg.gd} ${to}`)) {
                      Toaster.failure(null,
                        <Typography variant="small">
                          امکان رزرو برای تاریخ های قبلی از اکنون ممکن نیست!
                        </Typography>);
                      return
                    }
                    setSelectedScheduleToReserve({
                      'events': events,
                      'jalaliDate': jalaliDate,
                      'week_day_id': week_day_id,
                    })
                    setReserveFormModalOpen(true);
                  }
                }}
              />
            ))}
          </div>
        ))}

      </div>
    </div>
  );
};
